<template>
  <div class="BackendCreate">
    <el-form
        :model="user_form"
        status-icon
        :rules="user_form.id?rules_edit:rules_create"
        ref="ruleForm"
        size="medium"
        label-width="150px">

      <el-form-item label="User Id" prop="id">
        {{ user_form.id }}
      </el-form-item>
      <el-form-item label="User Name" prop="user_name">
        <el-input style="width: 300px" v-model="user_form.user_name" placeholder="Enter Name"></el-input>
      </el-form-item>

      <el-form-item label="User Spread Id" prop="spread_id">
        {{ user_form.spread_id }}
      </el-form-item>
      
      <el-form-item label="User Invite Code" prop="invite_code">
        {{ user_form.invite_code }}
        <!-- <el-input style="width: 300px" v-model="user_form.invite_code" placeholder="Enter Invite Code"></el-input> -->
      </el-form-item>
      
      <el-form-item label="User Spread Count" prop="spread_count">
        {{ user_form.spread_count }}
      </el-form-item>

      <el-form-item label="User Spread Limit" prop="spread_limit">
        <el-input style="width: 300px" v-model="user_form.spread_limit" placeholder="Spread Limit"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button
            type="primary"
            @click="onInvite">Enable Invite
        </el-button>
        <el-button
            type="danger"
            :disabled="!user_form.invite_code"
            @click="onDelete">Delete Invite
        </el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">{{uid===''?'Create':'Save'}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

  import {getUser, saveUser, verifyToken, deleteUserCode, createUserCode} from "@/utils/api";

  export default {
    props: ['uid'],
    data() {
      let validateEmail = (rule, value, callback) => {
        let reg = new RegExp("^[A-Za-z0-9]+([._\\-]*[A-Za-z0-9])*@([A-Za-z0-9]+[-A-Za-z0-9]*[A-Za-z0-9]+.){1,63}[A-Za-z0-9]+$");
        if (value === "") {
          callback(new Error('Email is required'));
        } else if (!reg.test(value)) {
          callback(new Error('Invalid Email'));
        } else {
          callback();
        }
      };
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Password is required'));
        } else {
          if (this.user_form.check_pass !== '') {
            this.$refs.ruleForm.validateField('check_pass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Enter password again'));
        } else if (value !== this.user_form.pass) {
          callback(new Error('Password mismatch!'));
        } else {
          callback();
        }
      };
      return {
        option_list: [
          {
            name: 'Rating',
            num: 1
          },
          {
            name: 'Comment',
            num: 2
          },
          {
            name: 'Video',
            num: 3
          }
        ],
        role_list: [
          {
            access: 1,
            name: 'Admin'
          }, {
            access: 2,
            name: 'Vendor'
          },
        ],
        current_user: {},
        edit_udata: {

        },
        user_form: {
          id: '',
          user_name: '',
          spread_id: '',
          invite_code: '',
          spread_count: '',
          spread_limit: '',
        },
        rules_create: {
          name: [
            {required: true, message: 'Name is required', trigger: 'blur'},
          ],
          email: [
            {required: true, message: 'Email is required', trigger: 'blur'},
            {validator: validateEmail, trigger: 'blur'}
          ],
          access: [
            {required: true, message: 'User role is required', trigger: 'change'},
          ],
          pass: [
            {required: true, message: 'Password is required', trigger: 'blur'},
            {validator: validatePass, trigger: 'blur'}
          ],
          check_pass: [
            {required: true, message: 'Enter password again', trigger: 'blur'},
            {validator: validatePass2, trigger: 'blur'}
          ],

        },
        rules_edit: {
          // name: [
          //   {required: true, message: 'Name is required', trigger: 'blur'},
          // ],
          // email: [
          //   {required: true, message: 'Email is required', trigger: 'blur'},
          //   {validator: validateEmail, trigger: 'blur'}
          // ],
          // access: [
          //   {required: true, message: 'User role is required', trigger: 'change'},
          // ],
        }
      };
    },
    methods: {
      onInvite() {
        this.$confirm(`Are you sure you want to Enable this user's Invite Code?`, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          createUserCode(this.uid).then(() => {
            this.$emit('update')
          })
        }).catch(() => {});
      },
      onDelete() {
        this.$confirm(`Are you sure you want to Delete this user's Invite Code?`, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          deleteUserCode(this.uid).then(() => {
            this.$emit('update')
          })
        }).catch(() => {});
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            saveUser(this.user_form).then(res => {
              if (res.errcode === 0) {
                this.$message.success('User Saved!');
                this.$emit('update');
                verifyToken().then(res => {
                  if (res.errcode !== 0) {
                    this.$router.replace('/login')
                  }
                })
              } else if (res.errcode === 1) {
                this.$message.error('Error');
              } else if (res.errcode === 2) {
                this.$message.error('Email has been taken');
              }
            })
          } else {
            this.$message.warning('Check your inputs')
          }
        });
      },
    },
    beforeMount() {
      if (this.uid !== '') {

        getUser({
          id: this.uid,
          page:1,
          size:10
        }).then(res => {
          res.user_list.forEach(item => {
            if (item.id == this.uid) {
              this.edit_udata = item
              this.user_form.id = item.id
              this.user_form.user_name = item.user_name
              this.user_form.spread_id = item.spread_id
              this.user_form.invite_code = item.invite_code
              this.user_form.spread_count = item.spread_count
              this.user_form.spread_limit = item.spread_limit
            }
          })

          // this.pagination.total = res.total
          // this.pagination.page = res.page
          // this.pagination.size = res.size
        })
        // getBackendUser(this.uid).then(res => {
        //   let user = res.backend_list[0];
        //   let check_list = [];
        //   if (user.rate_enable) {
        //     check_list.push('Rating')
        //   }
        //   if (user.review_enable) {
        //     check_list.push('Comment')
        //   }
        //   if (user.video_enable) {
        //     check_list.push('Video')
        //   }
        //   this.user_form = {
        //     id: user.user_id,
        //     name: user.user_name,
        //     email: user.user_email,
        //     access: user.user_access,
        //     pass: '',
        //     check_pass: '',
        //     check_list: check_list
        //   }
        // })
      }
    }
  };
</script>
